<template>
  <div class="roomGeneralViewManagement clearfix" v-loading="loading">
    <div class="roomItem" v-for="(item,index) in bedList" :key="index">
      <!-- by guo 2020-3-13-10:48修改 -->
      <div class="roomItem-room">
        <!-- <span style="font-size:16px;text-align:center;position:absolute">{{item.bedNo}}</span> -->
        <span style="font-size:14px;text-align:left;">{{item.remark}}</span>
        <span style="font-size:13px;float: right;">{{item.oldmanName}}</span>
      </div>
      <!-- <div class="roomItem-div" :class="{'roomItem-div-active':item.alarmFlag==true}" style="background:#ffffff" @click="handleRoomItem(item,index)"> -->
      <div class="roomItem-div" @click="handleBedItem(item,index)">
        <div class="roomItem-div-img">
          <el-carousel :interval="5000" trigger="click" :autoplay="true" :ref="'carousel' + index" indicator-position="none" arrow="never">
            <el-carousel-item v-for="(temp,index2) in item.img" :key="index2" :style="{background:temp.background}" class="carousel-item-active">
              <img :src="temp.images" alt="" style="height:60%;margin:0 auto; padding-top:2px;max-width: 100px;object-fit: scale-down;">
              <!-- by guo 2020-3-16-13:24修改  需求变更 去掉温度的显示  修改为对应报警的文字 -->
              <div class="roomItem-div-text" style="margin:0 auto; overflow:hidden;align-items: center;font-size:20px;display: flex;justify-content: center;" :title="temp.alarmMsg">
                <p v-html="temp.alarmMsg"></p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import offLine from '@/assets/device/gatewayOff.png';//设备离线
import xindian from '@/assets/device/xinlv_err.png'; //心率1异常
import statusinbed from '@/assets/device/life_status_inbed.png';//在床
import statusoutbed from '@/assets/device/life_status_outbed.png';//离床
export default {
  name: "radarKanBan",
  data() {
    return {
      size:"medium",//按钮的尺寸
      isActive:0,//默认第一个被选中  通过点击来切换  被点击的就给一个被选中的样式
      buildList:[],//查询所有的楼栋
      currentBuild:{},
      bedList:[],
      ids:[],
      buildingId:"",
      actionrun:null,
      timeOne:null,
      timeTwo:null,
      loading:true,
    };
  },
  methods: {
    /*  
      点击房间跳转到房间详情
    */
    handleBedItem(item,index){
      bus.$emit("homePage", {
        type: "jump",
        path: "/RadarDetail",
        title: '雷达数据',
        params: {
          deviceNo:item.deviceNo
        }
      });
    },
    /**
     * 根据bed获取设备
     */
    getDeviceList(){
      let param = {
        pageNum: 1,
        pageSize: 999,
      };
      this.$postJson("dmc/fallRadar/queryRadarDataListWithPage", param).then(res =>{
        this.loading = false;
        this.showData(res.result.list);
      })
    },
    showData(bedDeviceList){
      for(let i=0;i<bedDeviceList.length;i++){
        bedDeviceList[i].img=new Array();
        //没有设备
          if(bedDeviceList[i].offLine == 1){ //离线
            bedDeviceList[i].img.push({'images':offLine,'alarmMsg':"设备离线",isbgFlag:true,'background':"#ffffff"});
            bedDeviceList[i].background="#ffffff";
          }else if(bedDeviceList[i].inStatus == 1){ //在床
            let color1 = "#13870e";
            let color2 = "#2da228";
            if(bedDeviceList[i].heartRate>100 || bedDeviceList[i].heartRate <60){
              color1 = "#f18926";
            }
            if(bedDeviceList[i].breathRate>20 || bedDeviceList[i].breathRate <8){
              color2 = "#f18926";
            }
            let msg = "<span style='color:"+color1+"'>"+" 心率"+bedDeviceList[i].heartRate+"</span>" + 
            "<span style='color:"+color2+";font-size:14px'>"+"   呼吸"+bedDeviceList[i].breathRate+"</span>";
            bedDeviceList[i].img.push({'images':statusinbed,'alarmMsg':msg,isbgFlag:true,'background':"#ffffff"});
            bedDeviceList[i].background="#ffffff";
            if(bedDeviceList[i].heartRate>100 || bedDeviceList[i].heartRate <45){
              bedDeviceList[i].img.push({'images':xindian,'alarmMsg':"心率异常",isbgFlag:true,'background':"#ffffff"});
              bedDeviceList[i].background="#00ff00";
            }
            if(bedDeviceList[i].breathRate>30 || bedDeviceList[i].breathRate <5){
              bedDeviceList[i].img.push({'images':xindian,'alarmMsg':"呼吸异常",isbgFlag:true,'background':"#ffffff"});
              bedDeviceList[i].background="#00ff00";
            }
          }else { //离床
            let msg = "老人离开";
            bedDeviceList[i].img.push({'images':statusoutbed,'alarmMsg':msg,isbgFlag:true,'background':"#ffffff"});
            bedDeviceList[i].background="#ffffff";
          }
        }
        this.bedList = bedDeviceList;
      }
    },
  created() {
    //每过2min刷新一次?
    this.getDeviceList();
    this.timeOne = setInterval(() => {
      this.getDeviceList();
    }, 1 * 20 * 1000);
  },
  destroyed() {
    clearInterval(this.timeOne);
  },
};
</script>
<style lang="scss" scoped>
  .roomGeneralViewManagement{
    .toolbar{
      margin: 0px 0px !important;
    }
    .formItemButton{
      border:1px solid #8d8d8d;
      color:#8d8d8d;
    }
    .buttonActive{
      background: #3a77e2;
      color:#fefefe;
    }
    //by guo 2020-3-16-16:31添加
    .roomItem-div-text{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-weight: 600 !important;
    }
    
    @media (max-width: 1023px){ 
      .roomItem{
        float: left;
        width: 22%;
        height: 150px;
        margin:1.3%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 80px;
            // line-height: 80px;
            img{
              vertical-align: middle;
            }  
          }
          .roomItem-div-text{
            height:50px;
            // line-height: 22px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 140px;
        }
        ::v-deep .el-carousel__container {
          height: 140px;
        }
      }
    }
    @media (min-width: 1024px){ 
      .roomItem{
        float: left;
        width: 16%;
        height: 150px;
        margin:1.3%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 80px;
            // line-height: 80px;
            img{
              vertical-align: middle;
            }  
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 120px;
        }
        ::v-deep .el-carousel__container {
          height: 120px;
        }
      }
    }
    @media (min-width: 1100px) {
      .roomItem{
        float: left;
        width: 14%;
        height: 150px;
        margin:1.3%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 80px;
            // line-height: 80px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 140px;
        }
        ::v-deep .el-carousel__container {
          height: 140px;
        }
      }
    } 
    @media (min-width: 1366px) {
      .roomItem{
        float: left;
        width: 12%;
        height: 160px;
        margin:1%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:140px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 70px;
            // line-height: 70px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 140px;
        }
        ::v-deep .el-carousel__container {
          height: 140px;
        }
      }
    }  
    @media (min-width: 1440px) {
       .roomItem{
        float: left;
        width: 12%;
        height: 160px;
        margin:1%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 80px;
            // line-height: 80px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4 !important;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 120px;
        }
        ::v-deep .el-carousel__container {
          height: 120px;
        }
      }
    }
    @media (min-width: 1680px) {
       .roomItem{
        float: left;
        width: 9%;
        height: 160px;
        margin:0.72%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 110px;
            // line-height: 110px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 120px;
        }
        ::v-deep .el-carousel__container {
          height: 120px;
        }
      }
    } 
    @media (min-width: 1920px) {
       .roomItem{
        float: left;
        width: 7%;
        height: 170px;
        margin:0.72%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          color:#666666;
          font-size: 16px;
        }
        .roomItem-div{
          height:130px;
          background: #ffffff;
          color: #343434;
          .roomItem-div-img{
            height: 110px;
            // line-height: 110px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 130px;
        }
        ::v-deep .el-carousel__container {
          height: 130px;
        }
      }
    } 
  }
   //by guo 2020-3-28-15:55修改 注释
  // ::v-deep .roomItem-div .el-carousel__container {
  //   height: 140px;
  // }
  ::v-deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view{
    white-space: nowrap;
    width:100%;
    height:100%;
    overflow-x: auto;
  }
  ::v-deep .el-form--inline{
    position: relative;
    z-index: 99;
  }
  .filtersposition{
    position: absolute;
    top:-10px;
    left:0;
    right:0;
    bottom:10px;
    width:100%;
    max-height:56px;
    background: #F2F2F2;
    z-index:1;
  }
  //by guo 2020-3-28-15:55修改  去掉屏幕缩放时的房间一览小块的y轴滚动条
  ::v-deep .roomItem-div .el-carousel--horizontal{
    overflow-y: hidden;
  }
</style>